import {
  EmptyStateEmail as EmptyStateEmbeddedDesktop,
  EmptyStateInApp as EmptyStateEmbeddedMobile,
} from 'ui/illustrations';
import { DISPLAY_CONTENT, Platform } from '../constants';
import { EmptyStateContainer, EmptyStateText } from './styles';

type Props = {
  platform: Platform;
};

export const EmptyState = ({ platform }: Props) => {
  return (
    <EmptyStateContainer platform={platform}>
      {platform === Platform.DESKTOP ? <EmptyStateEmbeddedDesktop /> : <EmptyStateEmbeddedMobile />}
      <EmptyStateText>{DISPLAY_CONTENT.preview.emptyPreview}</EmptyStateText>
    </EmptyStateContainer>
  );
};
